import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/tabelaprecos/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function findTabelaPrecos(empresa_cnpj) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "GET", headers);
}
